'use client';

import { Dialog, Transition } from '@headlessui/react';
import { type FC, Fragment, type ReactNode } from 'react';

export interface ModalProps {
  isOpened: boolean;
  modalContent?: ReactNode;
}

const Modal: FC<ModalProps> = ({ isOpened, modalContent }) => {
  return (
    <Transition.Root show={isOpened ?? false} as={Fragment}>
      <Dialog as="div" className="relative z-[100]" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-DimmedEffect-40 transition-opacity" />
        </Transition.Child>
        <div className="fixed flex justify-center items-center inset-0 z-10 w-screen overflow-y-auto">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <Dialog.Panel
              itemID={'headlessui-dialog-panel'}
              className="relative transform rounded-lg bg-white text-left shadow-xl transition-all "
            >
              <div>{modalContent}</div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Modal;
